import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';

import Routes from './routes';
import Layout from './components/Layout';

class Root extends React.Component {

  static propTypes = {
    store: PropTypes.object.isRequired
  }

  render() {
    return (
      <Provider store={ this.props.store }>
        <BrowserRouter>
          <Layout>
            <Route path='/' component={ Routes } />
          </Layout>
        </BrowserRouter>
      </Provider>
    );
  }

}

export default Root;



// WEBPACK FOOTER //
// ./src/app/index.js